import { defineComponent as _defineComponent } from 'vue'
import { getCurrentInstance, onBeforeUnmount, onMounted, ref } from 'vue'
import { signOut } from '@/util/signOut'


const __default__ = { name: 'sidebar-user-menu' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

// Signed-in user card at the bottom of the sidebar (port of the otc-admin user menu).
// Opens My profile and Sign out; sign out goes through the shared helper so it keeps the
// same device preferences as the navbar's phone row.
const proxy = getCurrentInstance()!.proxy as any
const PLACEHOLDER_IMG = 'https://console.offthecouch.io/img/placeholder.jpg'

function readProfile(): any {
  try {
    return JSON.parse(localStorage.getItem('profile') || '{}') || {}
  } catch (e) {
    return {}
  }
}

const profile = readProfile()
const fullName: string = [profile.first_name, profile.last_name].filter(Boolean).join(' ')
const email: string = profile.email || ''
const img: string = profile.img && profile.img !== PLACEHOLDER_IMG ? profile.img : ''
const initials: string = (
  [profile.first_name, profile.last_name].filter(Boolean).map((n: string) => n.charAt(0)).join('') ||
  email.charAt(0) ||
  '?'
).toUpperCase()

const root = ref<HTMLElement | null>(null)
const open = ref(false)

function goToProfile(): void {
  open.value = false
  proxy.$router.push('/settings/profile')
}

async function logout(): Promise<void> {
  open.value = false
  await signOut(proxy.$router, proxy.$route.fullPath)
}

function onDocMouseDown(e: MouseEvent): void {
  if (open.value && root.value && !root.value.contains(e.target as Node)) open.value = false
}

function onDocKey(e: KeyboardEvent): void {
  if (e.key === 'Escape' && open.value) open.value = false
}

onMounted(() => {
  document.addEventListener('mousedown', onDocMouseDown)
  document.addEventListener('keydown', onDocKey)
})

onBeforeUnmount(() => {
  document.removeEventListener('mousedown', onDocMouseDown)
  document.removeEventListener('keydown', onDocKey)
})

return { __sfc: true,proxy, PLACEHOLDER_IMG, readProfile, profile, fullName, email, img, initials, root, open, goToProfile, logout, onDocMouseDown, onDocKey }
}

})